import PropTypes from 'prop-types';
import React from 'react';
import CommonIriDisplay from '../application-core/CommonIriDisplay';
import { getProjectFromGraph, sortResources } from '../core/utils/utils';
import TitledPanel from '../core/TitledPanel';

class DocumentSource extends React.Component {

    render() {

        const { componentIRI, sources, graph, viewLang, defaultLang, dataTest } = this.props;

        if (!sources) return null;
        const otherSources = sources.length === 1 ? sources.filter(s => s !== componentIRI) : sources;
        if (otherSources.length === 0) return null;

        // Should be loaded already so okay to sort on the data
        const sortedResources = sortResources(otherSources, graph, "title", defaultLang);

        return (
            <TitledPanel dataTest={dataTest} height="full" title="Document Sources">
                {
                    sortedResources.map(s => <CommonIriDisplay
                        id={s}
                        key={s}
                        compact={true}
                        projectIRI={getProjectFromGraph(graph)}
                        handleNotAvailable={true}
                        loadComponents={true}
                        graph={graph}
                        viewLang={viewLang}
                        defaultLang={defaultLang} />
                    )}
            </TitledPanel>
        );
    }
}

DocumentSource.defaultProps = {
    dataTest: "document-sources"
};

DocumentSource.propTypes = {
    dataTest: PropTypes.string,
    graph: PropTypes.string.isRequired,
    componentIRI: PropTypes.string.isRequired,
    sources: PropTypes.array
};

export default DocumentSource;